import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import Select from "react-select";
import "react-quill/dist/quill.snow.css";
import {
  useGetAllCityQuery,
  useGetCountryQuery,
} from "../../app/features/account/accountApi";
import {
  useContactUsForHousingMutation,
  useGetMyHousingRequestByIdQuery,
  useGetMyHousingRequestQuery,
  useUpdateMyHousingRequestByIdMutation,
} from "../../app/features/housing/housingApi";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import SEOData from "../../components/SEO/SEO";

const UpdateMyRequest = () => {
  const editorStyle = {
    border: "1px solid #ccc", // Custom border
    borderRadius: "8px", // Custom border radius
    padding: "15px", // Custom padding inside the editor
    height: "250px", // Custom height
    fontFamily: "Arial, sans-serif", // Custom font
    fontSize: "16px", // Custom font size
    overflowY: "auto", // Scroll if content overflows
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6] }],
      [{ size: [] }],
      [{ color: [] }, { background: [] }], // Add color and background color options
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"], // remove formatting button
    ],
  };
  const params = useParams();
  // console.log(params);

  const { data: myHousing, loading: myHousingLoading } =
    useGetMyHousingRequestByIdQuery(params?.id);

  const {
    data: countries,
    loading: countryLoading,
    refetch: countryRefetch,
  } = useGetCountryQuery(undefined);
  const {
    data: allCitys,
    error: allCitysError,
    loading: allCitysLoading,
    refetch: allCitysReferth,
  } = useGetAllCityQuery();

  const countryLocation = countries?.map((country) => ({
    value: country.id,
    label: country.name,
  }));
  const cityLocation = allCitys?.results?.map((country) => ({
    value: country.id,
    label: country.name,
  }));
  const typeOfHousing = [
    { value: "full", label: "Full Appartment" },
    { value: "shared", label: "Shared Appartment" },
  ];

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "both", label: "Both" },
  ];

  const occupancyOptions = [
    { value: "single", label: "Single" },
    { value: "double", label: "Married" },
  ];

  const [updateMyHousingRequestById] = useUpdateMyHousingRequestByIdMutation();
  const [description, setDescription] = useState("");
  const navigate = useNavigate();

  const {
    register,
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    // console.log(data);
    const contactData = {
      name: data?.yourName,
      email: data?.email,
      phone: data?.phone,
      location: data?.location,
      gender: data?.gender,
      occupancy: data?.occupancy,
      accommodation: data?.appartmentType,
      country: data?.country,
      city: data?.city,
      description: description || "",
    };
    // console.log(contactData);
    const toastId = toast.loading("Updating Your Request. Please wait...");
    try {
      const res = await updateMyHousingRequestById({
        id: params?.id,
        data: contactData,
      }).unwrap();
      if (res.id) {
        toast.success("Successfully Updated your Request.", { id: toastId });
        navigate("/student/my-house-request");
        reset();
        setDescription("");
      }
      // console.log(res);
    } catch (error) {
      // console.log(error)
      if (error?.name === "SyntaxError") {
        toast.error(
          "We encountered a technical issue. Please clear your browser cookies and try again. If the issue persists, reach out to support for assistance.",
          { id: toastId, duration: 5000 }
        );
      } else if (error?.status === "FETCH_ERROR") {
        toast.error(
          "Network Error: Unable to connect to the server. Please check your internet connection or try again later.",
          { id: toastId, duration: 5000 }
        );
      } else {
        toast.error(
          "We couldn’t process your request because some information are missing. Kindly check and try once more.",
          {
            id: toastId,
            duration: 5000,
          }
        );
      }
    }
  };
  // console.log(myHousing);

  useEffect(() => {
    if (myHousing?.name) {
      setValue("yourName", myHousing?.name);
    }
    if (myHousing?.email) {
      setValue("email", myHousing?.email);
    }
    if (myHousing?.phone) {
      setValue("phone", myHousing?.phone);
    }
    if (myHousing?.country) {
      setValue("country", myHousing?.country);
    }
    if (myHousing?.city) {
      setValue("city", myHousing?.city);
    }
    if (myHousing?.location) {
      setValue("location", myHousing?.location);
    }
    if (myHousing?.accommodation) {
      setValue("appartmentType", myHousing?.accommodation);
    }
    if (myHousing?.gender) {
      setValue("gender", myHousing?.gender);
    }
    if (myHousing?.gender) {
      setValue("gender", myHousing?.gender);
    }
    if (myHousing?.occupancy) {
      setValue("occupancy", myHousing?.occupancy);
    }
    if (myHousing?.description) {
      setDescription(myHousing?.description || "");
    }
  }, [myHousing, setValue]);

  return (
    <div className=" pt-2 pb-10 bg-[#f4e0f271]">
      <SEOData
        title={`UniEdu || Update Requested Housing`}
        description={`UniEdu Update Requested Housing page.`}
        canonical={window.location.pathname}
      />
      <div className="bg-slate-100 lg:w-[900px] mx-auto  p-5 lg:p-10 rounded-xl mt-5 shadow-lg">
        <div className="flex justify-center items-center">
          <h3 className="text-2xl text-blue-500 font-semibold   ">
            Personalize Your Housing Search
          </h3>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-10 gap-5 pt-10">
            {/* Company Name */}
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-5 mb-4">
              <div className="flex items-center">
                <div className="w-1/3">
                  <label className="font-medium text-sm">Your Name</label>
                </div>
                <div className="w-2/3">
                  <input
                    type="text"
                    placeholder="Your Name"
                    className="w-full h-full py-3 px-2 border-none rounded-lg focus:outline-blue-200 placeholder:text-sm"
                    {...register("yourName", { required: true })}
                  />
                  {errors.yourName && (
                    <span className="text-red-500">This field is required</span>
                  )}
                </div>
              </div>
            </div>

            {/* Representative Name */}
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-5 mb-4">
              {/* Email */}
              <div className="flex items-center">
                <div className="w-1/3">
                  <label className="font-medium text-sm">Email</label>
                </div>
                <div className="w-2/3">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    readOnly
                    className="w-full h-full py-3 px-2 border-none rounded-lg focus:outline-blue-200 placeholder:text-sm"
                    {...register("email", { required: true })}
                  />
                  {errors.email && (
                    <span className="text-red-500">
                      A valid email is required
                    </span>
                  )}
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-center">
                <div className="w-1/3">
                  <label className="font-medium text-sm">Phone</label>
                </div>
                <div className="w-2/3">
                  <input
                    type="text"
                    placeholder="Your phone number"
                    className="w-full h-full py-3 px-2 border-none rounded-lg focus:outline-blue-200 placeholder:text-sm"
                    {...register("phone", { required: true })}
                  />
                  {errors.phone && (
                    <span className="text-red-500">This field is required</span>
                  )}
                </div>
              </div>

              {/* Country */}
              <div className="flex items-center">
                <div className="w-1/3">
                  <label className="font-medium text-sm">Country</label>
                </div>
                <div className="w-2/3">
                  <div>
                    <Controller
                      name="country"
                      control={control}
                      rules={{
                        required: "This field is required",
                      }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={countryLocation}
                          value={countryLocation?.find(
                            (option) => option.value === field.value
                          )}
                          // onChange={(selectedOption) =>
                          //   field.onChange(
                          //     selectedOption ? selectedOption.value : null
                          //   )
                          // }
                          onChange={(selectedOption) => {
                            field.onChange(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                          isClearable
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              outline: "none",
                              border: "none",
                              padding: "5px 0",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              fontSize: "14px",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              color: "blue",
                              fontWeight: "bold",
                            }),
                            multiValue: (provided) => ({
                              ...provided,
                              fontWeight: "500",
                              padding: "2px 0",
                              background: "white",
                              border: "1px solid #ddd",
                              borderRadius: "5px",
                              marginLeft: "10px",
                            }),
                            multiValueLabel: (provided) => ({
                              ...provided,
                              opacity: "0.8",
                            }),
                          }}
                          placeholder="Select your country"
                          isSearchable
                          // isMulti
                          noOptionsMessage={() => "No Match found"}
                        />
                      )}
                    />
                    {errors.country && (
                      <p className="text-red-500 font-medium ml-3 mt-1">
                        {errors.country.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {/* Country */}
              <div className="flex items-center">
                <div className="w-1/3">
                  <label className="font-medium text-sm">City</label>
                </div>
                <div className="w-2/3">
                  <div>
                    <Controller
                      name="city"
                      control={control}
                      rules={{
                        required: "This field is required",
                      }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={cityLocation}
                          value={cityLocation?.find(
                            (option) => option.value === field.value
                          )}
                          // onChange={(selectedOption) =>
                          //   field.onChange(
                          //     selectedOption ? selectedOption.value : null
                          //   )
                          // }
                          onChange={(selectedOption) => {
                            field.onChange(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                          isClearable
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              outline: "none",
                              border: "none",
                              padding: "5px 0",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              fontSize: "14px",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              color: "blue",
                              fontWeight: "bold",
                            }),
                            multiValue: (provided) => ({
                              ...provided,
                              fontWeight: "500",
                              padding: "2px 0",
                              background: "white",
                              border: "1px solid #ddd",
                              borderRadius: "5px",
                              marginLeft: "10px",
                            }),
                            multiValueLabel: (provided) => ({
                              ...provided,
                              opacity: "0.8",
                            }),
                          }}
                          placeholder="Select your city"
                          isSearchable
                          // isMulti
                          noOptionsMessage={() => "No Match found"}
                        />
                      )}
                    />
                    {errors.city && (
                      <p className="text-red-500 font-medium ml-3 mt-1">
                        {errors.city.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-center">
                <div className="w-1/3">
                  <label className="font-medium text-sm">
                    Area/City for Housing
                  </label>
                </div>
                <div className="w-2/3">
                  <input
                    type="text"
                    placeholder="Your Address"
                    className="w-full h-full py-3 px-2 border-none rounded-lg focus:outline-blue-200 placeholder:text-sm"
                    {...register("location", { required: true })}
                  />
                  {errors.location && (
                    <span className="text-red-500">This field is required</span>
                  )}
                </div>
              </div>

              <div className="flex items-center">
                <div className="w-1/3">
                  <label className="font-medium text-sm">
                    Accommodation Type
                  </label>
                </div>
                <div className="w-2/3">
                  <div>
                    <Controller
                      name="appartmentType"
                      control={control}
                      rules={{
                        required: "This field is required",
                      }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={typeOfHousing}
                          value={typeOfHousing?.find(
                            (option) => option.value === field.value
                          )}
                          // onChange={(selectedOption) =>
                          //   field.onChange(
                          //     selectedOption ? selectedOption.value : null
                          //   )
                          // }
                          onChange={(selectedOption) => {
                            field.onChange(
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                          isClearable
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              outline: "none",
                              border: "none",
                              padding: "5px 0",
                            }),
                            placeholder: (provider) => ({
                              ...provider,
                              fontSize: "14px",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              color: "blue",
                              fontWeight: "bold",
                            }),
                            multiValue: (provided) => ({
                              ...provided,
                              fontWeight: "500",
                              padding: "2px 0",
                              background: "white",
                              border: "1px solid #ddd",
                              borderRadius: "5px",
                              marginLeft: "10px",
                            }),
                            multiValueLabel: (provided) => ({
                              ...provided,
                              opacity: "0.8",
                            }),
                          }}
                          placeholder="Select your Appartment Type"
                          isSearchable
                          // isMulti
                          noOptionsMessage={() => "No Match found"}
                        />
                      )}
                    />
                    {errors.appartmentType && (
                      <p className="text-red-500 font-medium ml-3 mt-1">
                        {errors.appartmentType.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* <div className="flex items-center">
              <div className="w-1/3">
                <label className="font-medium text-sm">Gender</label>
              </div>
              <div className="w-2/3">
                <div>
                  <Controller
                    name="country"
                    control={control}
                    rules={{
                      required: "This field is required",
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={genderOptions}
                        value={genderOptions?.find(
                          (option) => option.value === field.value
                        )}
                        // onChange={(selectedOption) =>
                        //   field.onChange(
                        //     selectedOption ? selectedOption.value : null
                        //   )
                        // }
                        onChange={(selectedOption) => {
                          field.onChange(
                            selectedOption ? selectedOption.value : null
                          );
                        }}
                        isClearable
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            outline: "none",
                            border: "none",
                            padding: "5px 0",
                          }),
                          placeholder: (provider) => ({
                            ...provider,
                            fontSize: "14px",
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            color: "blue",
                            fontWeight: "bold",
                          }),
                          multiValue: (provided) => ({
                            ...provided,
                            fontWeight: "500",
                            padding: "2px 0",
                            background: "white",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            marginLeft: "10px",
                          }),
                          multiValueLabel: (provided) => ({
                            ...provided,
                            opacity: "0.8",
                          }),
                        }}
                        placeholder="Select your country"
                        isSearchable
                        // isMulti
                        noOptionsMessage={() => "No Match found"}
                      />
                    )}
                  />
                  {errors.country && (
                    <p className="text-red-500 font-medium ml-3 mt-1">
                      {errors.country.message}
                    </p>
                  )}
                </div>
              </div>
            </div>  
            <div className="flex items-center">
              <div className="w-1/3">
                <label className="font-medium text-sm">Age Group </label>
              </div>
              <div className="w-2/3">
                <div>
                  <Controller
                    name="country"
                    control={control}
                    rules={{
                      required: "This field is required",
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={ageGroupOptions}
                        value={ageGroupOptions?.find(
                          (option) => option.value === field.value
                        )}
                        // onChange={(selectedOption) =>
                        //   field.onChange(
                        //     selectedOption ? selectedOption.value : null
                        //   )
                        // }
                        onChange={(selectedOption) => {
                          field.onChange(
                            selectedOption ? selectedOption.value : null
                          );
                        }}
                        isClearable
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            outline: "none",
                            border: "none",
                            padding: "5px 0",
                          }),
                          placeholder: (provider) => ({
                            ...provider,
                            fontSize: "14px",
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            color: "blue",
                            fontWeight: "bold",
                          }),
                          multiValue: (provided) => ({
                            ...provided,
                            fontWeight: "500",
                            padding: "2px 0",
                            background: "white",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            marginLeft: "10px",
                          }),
                          multiValueLabel: (provided) => ({
                            ...provided,
                            opacity: "0.8",
                          }),
                        }}
                        placeholder="Select your country"
                        isSearchable
                        // isMulti
                        noOptionsMessage={() => "No Match found"}
                      />
                    )}
                  />
                  {errors.country && (
                    <p className="text-red-500 font-medium ml-3 mt-1">
                      {errors.country.message}
                    </p>
                  )}
                </div>
              </div>
            </div>  
            <div className="flex items-center">
              <div className="w-1/3">
                <label className="font-medium text-sm">Occupancy Options</label>
              </div>
              <div className="w-2/3">
                <div>
                  <Controller
                    name="country"
                    control={control}
                    rules={{
                      required: "This field is required",
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={occupancyOptions}
                        value={occupancyOptions?.find(
                          (option) => option.value === field.value
                        )}
                        // onChange={(selectedOption) =>
                        //   field.onChange(
                        //     selectedOption ? selectedOption.value : null
                        //   )
                        // }
                        onChange={(selectedOption) => {
                          field.onChange(
                            selectedOption ? selectedOption.value : null
                          );
                        }}
                        isClearable
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            outline: "none",
                            border: "none",
                            padding: "5px 0",
                          }),
                          placeholder: (provider) => ({
                            ...provider,
                            fontSize: "14px",
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            color: "blue",
                            fontWeight: "bold",
                          }),
                          multiValue: (provided) => ({
                            ...provided,
                            fontWeight: "500",
                            padding: "2px 0",
                            background: "white",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            marginLeft: "10px",
                          }),
                          multiValueLabel: (provided) => ({
                            ...provided,
                            opacity: "0.8",
                          }),
                        }}
                        placeholder="Select your country"
                        isSearchable
                        // isMulti
                        noOptionsMessage={() => "No Match found"}
                      />
                    )}
                  />
                  {errors.country && (
                    <p className="text-red-500 font-medium ml-3 mt-1">
                      {errors.country.message}
                    </p>
                  )}
                </div>
              </div>
            </div>   */}

              <div>
                <h4 className="text-blue-500 font-semibold mb-2">Gender</h4>
                {genderOptions.map((option) => (
                  <div className="flex" key={option.value}>
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        {...register("gender", {
                          required: "Please select your gender",
                        })}
                        value={option.value}
                      />
                      {option.label}
                    </label>
                  </div>
                ))}
                {errors.gender && (
                  <p className="text-red-500 text-sm">
                    {errors.gender.message}
                  </p>
                )}
              </div>

              {/* Occupancy Options */}
              <div className="mt-2">
                <h4 className="text-blue-500 font-semibold mb-2">
                  Occupancy Options
                </h4>
                {occupancyOptions.map((option) => (
                  <div className="flex" key={option.value}>
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        {...register("occupancy", {
                          required: "Please select an occupancy option",
                        })}
                        value={option.value}
                      />
                      {option.label}
                    </label>
                  </div>
                ))}
                {errors.occupancy && (
                  <p className="text-red-500 text-sm">
                    {errors.occupancy.message}
                  </p>
                )}
              </div>
            </div>

            <div className="w-full mt-8 bg-white">
              <ReactQuill
                value={description}
                onChange={setDescription}
                style={editorStyle}
                modules={modules}
              />
            </div>

            <div className="flex justify-center mt-5">
              <button
                type="submit"
                className=" w-[300px] bg-btnColor-400 text-white font-semibold py-2 px-5 rounded-lg hover:bg-blue-600 transition"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateMyRequest;
